import validate from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a937dd94029dbe3564a583237b32d6f1/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a937dd94029dbe3564a583237b32d6f1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}